import axios from 'axios'
import { REACT_APP_API_ABM_FW } from '../../endpoints'

export async function getBranchOffices(carLotId, queryString = ''){  
    let results = ''
    try {
        results = await axios.get(`${REACT_APP_API_ABM_FW}/abms/branch_office/Car_lot/${carLotId}${queryString}`)
    } catch (error) {
        results = error.message
    }
    return results
}